import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const passwordViewer = {
    autoComplete: 'new-password',
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map